import React, { useState, useEffect } from "react";
import PreferenceTab from "../../components/Assets/AssetsTab/PreferenceTab";
import TabSelector from "../../components/TabSelector/TabSelector";
import SalaryComponentTable from "./SalaryComponentTable";
import AddSalaryComponent from "./AddSalaryComponent";
import "react-sliding-pane/dist/react-sliding-pane.css";
import SlidingPane from "react-sliding-pane";
import { useViewSalaryComponents } from "../../queries/payrollQuries";
import {SALARY_COMPONENT_TYPES} from "../../redux/constants/payrollComponents";

const PaySalaryComponent = () => {
  const [index, setIndex] = useState(0);
  const [isPaneOpen, setIsPaneOpen] = useState(false);
  const [filteredComponents, setFilteredComponents] = useState([]);
  const [editData, setEditData] = useState(null); 
const [filters, setFilters] = useState({
  date: null,
  added_by_role_id: 0,
  filter: "",
});

const appliedFilters = filters
  ? Object.fromEntries(
      Object.entries(filters).filter(
        ([key, value]) =>
          value !== null &&
          value !== undefined &&
          !(key === "added_by_role_id" && value === 0)
      )
    )
  : {};


const { data: salaryComponents, isLoading, error } = useViewSalaryComponents(appliedFilters);



const handleFilterChange = (updatedFilters) => {
  setFilters(updatedFilters);
};



useEffect(() => {
  if (salaryComponents?.data) {
    let filtered = salaryComponents.data;
    filtered = filtered.filter((item) =>
      (index === 0 && item.component_type === SALARY_COMPONENT_TYPES.EARNING) ||
      (index === 1 && item.component_type === SALARY_COMPONENT_TYPES.DEDUCTION)
    );

    setFilteredComponents(filtered);
  }
}, [index, salaryComponents]);

  const getTabIndex = (e) => {
    setIndex(e);
  };

  const handleEdit = (data) => {
    setEditData(data);           
    setIsPaneOpen(true);         
  };

  const handleClosePane = () => {
    setIsPaneOpen(false);
    setEditData(null);
  };
const handleBaseChange = (id, newValue) => {
  setFilteredComponents((prev) =>
    prev.map((comp) => {
      if (comp.salary_component_id === id) {
        return { ...comp, is_basic: newValue };
      }
      if (newValue) {
        return { ...comp, is_basic: false };
      }
      return comp;
    })
  );
};
const hasBaseComponent = filteredComponents.some((comp) => comp.is_basic === true);

  const tabs = ["Earning", "Deductions"];

  return (
    <div className="px-10 py-6 w-full">
      <div className="px-10 flex justify-between items-center">
        <h2 className="text-xl font-semibold">Salary Components</h2>
        <button
          type="button"
          className="btn text-sm font-medium"
          onClick={() => {
            setEditData(null); 
            setIsPaneOpen(true);
          }}
        >
          Add Salary Component
        </button>
      </div>

      <PreferenceTab tabs={tabs} getTabIndex={getTabIndex} tabIndex={index} />

      <TabSelector
        tabIndex={index}
        components={[
          <SalaryComponentTable
            key="earning"
            salaryComponents={filteredComponents}
            isLoading={isLoading}
            error={error}
            onEdit={handleEdit} 
            fetchFilteredData={handleFilterChange}
          />,
          <SalaryComponentTable
            key="deduction"
            salaryComponents={filteredComponents}
            isLoading={isLoading}
            error={error}
            onEdit={handleEdit} 
            fetchFilteredData={handleFilterChange}
          />,
        ]}
      />

      {isPaneOpen && (
        <SlidingPane
          isOpen={isPaneOpen}
          title={editData ? "Edit Salary Component" : "Add Salary Component"}
          from="right"
          width="450px"
          onRequestClose={handleClosePane}
        >
          <AddSalaryComponent
            closePane={handleClosePane}
            selectedTabIndex={index}
            editData={editData} 
            isEditMode={!!editData}
            hasBaseComponent={hasBaseComponent}
            title="Add Salary Component"
            
          />
        </SlidingPane>
      )}
    </div>
  );
};

export default PaySalaryComponent;
